/*---------------------------------------------------------*\
 * LogoController
\*---------------------------------------------------------*/
class LogoController {
  //-----------------------------------
  // Constructor
  //-----------------------------------
  constructor($timeout) {
    this.name = 'logo';
    this.$timeout = $timeout;
    this.$timeout(() => {
      const regionId = (this.region && this.region.abbr) ? this.region.abbr : 'LI';
      this.logoPath = this.getPath(regionId);
    });
  }

  //-----------------------------------
  // Methods
  //-----------------------------------
  getPath(region) {
    const prefix = '/assets/images/logos/';
    return `${prefix}N12${region}.png`;
  }
}

LogoController.$inject = [
  '$timeout'
];

export default LogoController;



/** WEBPACK FOOTER **
 ** ./client/app/components/common/logo/logo.controller.js
 **/